import { lazy } from "react";
import type { RouteObject } from "react-router";
import { NotFound } from "./not-found";
import RootLayout from "./root-layout";

// Lazy load routes
const AssetsExplorerPage = lazy(() =>
  import("./domain/assets-explorer/page").then((module) => ({
    default: module.AssetsExplorerPage,
  })),
);

export const routes: RouteObject[] = [
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <AssetsExplorerPage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];
